<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">
        <Toolbar class="p-mb-4">
          <template slot="left">
            <Button
              label="New"
              icon="pi pi-plus"
              class="p-button-success p-mr-2"
              @click="openNew"
            />
            <!--<Button label="Delete" icon="pi pi-trash" class="p-button-danger" @click="confirmDeleteSelected" :disabled="!selectedBranches || !selectedBranches.length" />-->
          </template>

          <template slot="right">
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters['global']"
                placeholder="Global Search"
                @input="updateSearch"
              />
            </span>
          </template>
        </Toolbar>

        <DataTable
          :value="branches"
          :paginator="true"
          class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
          :rows="10"
          dataKey="mbpBranchId"
          :rowHover="true"
          :selection.sync="selectedBranches"
          :filters="filters"
          :loading="loading"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="[5, 10, 25]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Branches"
        >
          <template #header>
            <div class="table-header">MBP Branches (Sites)</div>
          </template>

          <template #empty> No Branches loaded! </template>
          <template #loading> Loading MBP Branches. Please wait. </template>

          <Column
            field="id"
            header="Id"
            headerStyle="width: 5em"
            :sortable="true"
          >
            <template #body="slotProps">
              <span class="p-column-title">Id</span>
              {{ slotProps.data.id }}
            </template>
          </Column>
          <Column field="branchCode" header="Code" :sortable="true">
            <template #body="slotProps">
              <span class="p-column-title">Code</span>
              {{ slotProps.data.branchCode }}
            </template>
          </Column>
          <Column field="branchName" header="Branch Name" :sortable="true">
            <template #body="slotProps">
              <span class="p-column-title">Name</span>
              {{ slotProps.data.branchName }}
            </template>
          </Column>
          <Column field="branchManager" header="Manager" :sortable="true">
            <template #body="slotProps">
              <span class="p-column-title">Manager</span>
              {{ slotProps.data.branchManager }}
            </template>
          </Column>
          <Column field="dateCreated" header="Created On" :sortable="true">
            <template #body="slotProps">
              <span class="p-column-title">Manager</span>
              {{ slotProps.data.dateCreated }}
            </template>
          </Column>
          <Column field="Status" header="Status" :sortable="true">
            <template #body="slotProps">
              <span class="p-column-title">Status</span>
              {{ slotProps.data.status }}
            </template>
          </Column>
          <Column>
            <template #body="slotProps">
              <div :style="{ position: 'relative' }">
                <SplitButton
                  label="Edit"
                  icon="pi pi-pencil"
                  class="p-button-success p-mb-2"
                  @click="editBranch(slotProps.data)"
                  :model="getButtons(slotProps.data)"
                >
                </SplitButton>
              </div>
              <!-- <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success p-mr-2"
                @click="editBranch(slotProps.data)"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning"
                @click="confirmDeleteBranch(slotProps.data)"
              /> -->
            </template>
          </Column>
        </DataTable>
        <!-- Dialog to Create & Edit a Branch -->
        <Dialog
          :visible.sync="branchDialog"
          :style="{ width: '640px', overflowY: 'auto' }"
          header="Branch Details"
          :modal="true"
          class="p-fluid"
        >
          <div class="p-formgrid p-grid">
            <div class="p-field p-col">
              <label for="Code">Branch Code *</label>
              <InputText
                id="Code"
                v-model.trim="branch.branchCode"
                required="true"
                autofocus
                :class="{ 'p-invalid': submitted && !branch.branchCode }"
              />
              <small class="p-invalid" v-if="submitted && !branch.branchCode"
                >Branch Code is required.</small
              >
            </div>
            <div class="p-field p-col">
              <label for="branchName">Branch Name *</label>
              <InputText
                id="branchName"
                v-model.trim="branch.branchName"
                required="true"
                autofocus
                :class="{ 'p-invalid': submitted && !branch.branchName }"
              />
              <small class="p-invalid" v-if="submitted && !branch.branchName"
                >Branch Name is required.</small
              >
            </div>
          </div>
          <div class="p-formgrid p-grid">
            <div class="p-field p-col">
              <label for="address1">Address 1</label>
              <InputText
                id="address1"
                v-model.trim="branch.address1"
                required="false"
                autofocus
                :class="{ 'p-invalid': submitted && !branch.address1 }"
              />
            </div>
            <div class="p-field p-col">
              <label for="address2">Address 2</label>
              <InputText
                id="address2"
                v-model.trim="branch.address2"
                required="false"
                autofocus
                :class="{ 'p-invalid': submitted && !branch.address2 }"
              />
            </div>
          </div>
          <div class="p-formgrid p-grid">
            <div class="p-field p-col">
              <label for="address3">Address 3</label>
              <InputText
                id="address3"
                v-model.trim="branch.address3"
                required="false"
                autofocus
                :class="{ 'p-invalid': submitted && !branch.address3 }"
              />
            </div>
            <div class="p-field p-col">
              <label for="address4">City/Town</label>
              <InputText
                id="address4"
                v-model.trim="branch.address4"
                required="false"
                autofocus
                :class="{ 'p-invalid': submitted && !branch.address4 }"
              />
            </div>
          </div>
          <div class="p-formgrid p-grid">
            <div class="p-field p-col">
              <label for="postCode">Post Code</label>
              <InputText
                id="postCode"
                v-model.trim="branch.postCode"
                required="false"
                autofocus
                :class="{ 'p-invalid': submitted && !branch.postCode }"
              />
            </div>
            <div class="p-field p-col">
              <label for="country">Country</label>
              <InputText
                id="country"
                v-model.trim="branch.country"
                required="false"
                autofocus
                :class="{ 'p-invalid': submitted && !branch.country }"
              />
            </div>
          </div>
          <div class="p-formgrid p-grid">
            <div class="p-field p-col">
              <label for="branchManager">Branch Manager</label>
              <InputText
                id="branchManager"
                v-model.trim="branch.branchManager"
                required="false"
                autofocus
                :class="{ 'p-invalid': submitted && !branch.branchManager }"
              />
            </div>
          </div>
          <template #footer>
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-text"
              @click="hideDialog"
            />
            <Button
              label="Save"
              icon="pi pi-check"
              class="p-button-text"
              @click="saveBranch"
            />
          </template>
        </Dialog>
        <Dialog
          :visible.sync="deleteBranchDialog"
          :style="{ width: '450px', overflowY: 'auto' }"
          header="Confirm"
          :modal="true"
        >
          <div class="confirmation-content">
            <i
              class="pi pi-exclamation-triangle p-mr-3"
              style="font-size: 2rem"
            />
            <span v-if="branch"
              >Are you sure you want to delete <b>{{ branch.branchName }}</b
              >?</span
            >
          </div>
          <template #footer>
            <Button
              label="No"
              icon="pi pi-times"
              class="p-button-text"
              @click="deleteBranchDialog = false"
            />
            <Button
              label="Yes"
              icon="pi pi-check"
              class="p-button-text"
              @click="deleteBranch"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import SettingService from "@/service/SettingService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  data() {
    return {
      branches: null,
      branch: {},
      branchDialog: false,
      deleteBranchDialog: false,
      selectedBranches: null,
      filters: {},
      submitted: false,
      requesting: false
    };
  },
  computed: {
    loading() {
      if (this.branches && this.branches[0]) {
        return false;
      } else {
        if (this.requesting) {
          return true;
        } else {
          return false;
        }
      }
    }
  },
  branchesService: null,
  created() {
    this.branchesService = new SettingService();
  },
  mounted() {
    this.getAllBranches();

    if (this.$route.query.search) {
      this.filters = { global: this.$route.query.search };
    }
  },
  methods: {
    getAllBranches() {
      this.requesting = true;
      this.branchesService
        .getAllBranchesByHard()
        .then(data => {
          this.requesting = false;
          this.branches = data;
        })
        .catch(err => {
          this.requesting = false;

          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting branches",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "mbpBranches"'
          });
        });
    },
    getAllActiveBranchesByHard() {
      this.branchesService
        .getAllActiveBranchesByHard()
        .then(data => {})
        .catch(err => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeMbpBranches"'
          });
        });
    },
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.confirmDeleteBranch(data);
          }
        });
      }
      return buttons;
    },
    viewBranch(branch) {},
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    },
    openNew() {
      this.branch = {};
      this.submitted = false;
      this.branchDialog = true;
    },
    hideDialog() {
      this.branchDialog = false;
      this.submitted = false;
    },
    editBranch(branch) {
      this.branch.updatedBy = 101;
      this.branch = { ...branch };
      this.branchDialog = true;
    },
    saveBranch() {
      this.submitted = true;
      if (this.branch.id) {
        this.branchesService
          .updateBranch(this.branch.id, this.branch)
          .then(response => {
            this.$toast.add({
              severity: "success",
              summary: response.data,
              detail: "Branch Updated",
              life: 5000
            });
            this.branchDialog = false;
            this.branch = {};
            this.getAllBranches();
            this.getAllActiveBranchesByHard();
          })
          .catch(e => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating branch",
              life: 5000
            });
          });
      } else {
        this.branch.dateCreated = new Date().toLocaleString();
        this.branchesService
          .saveBranch(this.branch)
          .then(response => {
            this.$toast.add({
              severity: "success",
              summary: response.data,
              detail: "New Branch Saved",
              life: 5000
            });
            this.branchDialog = false;
            this.branch = {};
            this.getAllBranches();
            this.getAllActiveBranchesByHard();
          })
          .catch(e => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving branch",
              life: 5000
            });
          });
      }
    },
    confirmDeleteBranch(branch) {
      this.branch = branch;
      this.deleteBranchDialog = true;
    },
    deleteBranch() {
      this.deleteBranchDialog = false;
      this.branchesService
        .deleteBranch(this.branch.id)
        .then(response => {
          this.$toast.add({
            severity: "success",
            summary: response,
            detail: "Branch Deleted",
            life: 5000
          });
          this.branch = {};
          this.getAllBranches();
          this.getAllActiveBranchesByHard();
        })
        .catch(e => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "Error while deleting branch",
            life: 5000
          });
        });
    },
    exportCSV() {
      this.$refs.dt.exportCSV();
    },
    confirmDeleteSelected() {
      this.deleteBranchesDialog = true;
    },
    deleteSelectedBranches() {
      this.branches = this.branches.filter(
        val => !this.selectedBranches.includes(val)
      );
      this.deleteBranchDialog = false;
      this.selectedBranches = null;
      this.$toast.add({
        severity: "success",
        summary: "Successful",
        detail: "Branches Deleted",
        life: 5000
      });
    }
  }
};
</script>

<style scoped lang="scss">
.p-progressbar {
  height: 0.5rem;
  background-color: #d8dadc;

  .p-progressbar-value {
    background-color: #607d8b;
  }
}

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}

.p-datatable.p-datatable-customers {
  .p-datatable-header {
    padding: 1rem;
    text-align: left;
    font-size: 1.5rem;
  }

  .p-paginator {
    padding: 1rem;
  }

  .p-datatable-thead > tr > th {
    text-align: left;
  }

  .p-datatable-tbody > tr > td {
    cursor: auto;
  }

  .p-dropdown-label:not(.p-placeholder) {
    text-transform: uppercase;
  }
}

/* Responsive */
.p-datatable-customers .p-datatable-tbody > tr > td .p-column-title {
  display: none;
}

.customer-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-qualified {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-unqualified {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-negotiation {
    background: #feedaf;
    color: #8a5340;
  }

  &.status-new {
    background: #b3e5fc;
    color: #23547b;
  }

  &.status-renewal {
    background: #eccfff;
    color: #694382;
  }

  &.status-proposal {
    background: #ffd8b2;
    color: #805b36;
  }
}

.p-progressbar-value.ui-widget-header {
  background: #607d8b;
}

@media (max-width: 640px) {
  .p-progressbar {
    margin-top: 0.5rem;
  }
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.orders-subtable {
  padding: 1rem;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

.order-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.order-delivered {
    background: #c8e6c9;
    color: #256029;
  }

  &.order-cancelled {
    background: #ffcdd2;
    color: #c63737;
  }

  &.order-pending {
    background: #feedaf;
    color: #8a5340;
  }

  &.order-returned {
    background: #eccfff;
    color: #694382;
  }
}

@media screen and (max-width: 960px) {
  .p-datatable {
    &.p-datatable-customers {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        border-bottom: 1px solid var(--layer-2);

        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }
}
</style>
